import { PALETTE } from '../StageData';
import { ShadingPipeline } from '../../engine/ShadingPipeline';
import type { ShapeDrawFn } from './furnitureShapes';

export const craftDrawFns: Record<number, ShapeDrawFn> = {
  // STAGE 51: 福招き猫
  51: (ctx, cx, cy, mode) => {
    const drawCat = () => {
      ctx.beginPath();
      ctx.ellipse(cx, cy + 50, 85, 105, 0, 0, Math.PI * 2);
      ctx.arc(cx, cy - 60, 65, 0, Math.PI * 2);
      ctx.moveTo(cx - 55, cy - 100); ctx.lineTo(cx - 30, cy - 140); ctx.lineTo(cx - 5, cy - 100);
      ctx.moveTo(cx + 5, cy - 100); ctx.lineTo(cx + 30, cy - 140); ctx.lineTo(cx + 55, cy - 100);
    };

    if (mode === 'base') {
      ctx.fillStyle = '#FAF8F5'; drawCat(); ctx.fill();
      ctx.beginPath(); ctx.ellipse(cx + 65, cy - 80, 22, 45, 0.3, 0, Math.PI * 2); ctx.fill();
    } else if (mode === 'outline') {
      ShadingPipeline.renderCarvedOutline(ctx, () => {
        drawCat(); ctx.stroke();
        ctx.beginPath(); ctx.ellipse(cx + 65, cy - 80, 22, 45, 0.3, 0, Math.PI * 2); ctx.stroke();
        ctx.strokeRect(cx - 45, cy - 10, 90, 18);
        ctx.beginPath(); ctx.ellipse(cx, cy + 60, 30, 42, 0, 0, Math.PI * 2); ctx.stroke();
      });
    } else if (mode === 'targetPreview') {
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx, cy, 170, 210, PALETTE.white, 'ceramic');
      drawCat(); ctx.fill();
      ctx.beginPath(); ctx.ellipse(cx + 65, cy - 80, 22, 45, 0.3, 0, Math.PI * 2); ctx.fill();
      ctx.fillStyle = PALETTE.crimson;
      ctx.fillRect(cx - 45, cy - 10, 90, 18);
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx, cy + 60, 60, 84, PALETTE.gold, 'metallic');
      ctx.beginPath(); ctx.ellipse(cx, cy + 60, 30, 42, 0, 0, Math.PI * 2); ctx.fill();
      ShadingPipeline.renderSpecularGlint(ctx, cx - 25, cy - 80, 25, 25, 0.55);
    }
  },

  // STAGE 52: 必勝祈願・赤だるま
  52: (ctx, cx, cy, mode) => {
    const drawDarumaBody = () => {
      ctx.beginPath();
      ctx.ellipse(cx, cy + 30, 110, 125, 0, 0, Math.PI * 2);
    };

    if (mode === 'base') {
      ctx.fillStyle = '#FAF8F5'; drawDarumaBody(); ctx.fill();
      ctx.fillStyle = '#FAF8F5';
      ctx.beginPath(); ctx.ellipse(cx, cy - 25, 60, 50, 0, 0, Math.PI * 2); ctx.fill();
    } else if (mode === 'outline') {
      ShadingPipeline.renderCarvedOutline(ctx, () => {
        drawDarumaBody(); ctx.stroke();
        ctx.beginPath(); ctx.ellipse(cx, cy - 25, 60, 50, 0, 0, Math.PI * 2); ctx.stroke();
        ctx.beginPath(); ctx.arc(cx - 24, cy - 30, 10, 0, Math.PI * 2); ctx.stroke();
        ctx.beginPath(); ctx.arc(cx + 24, cy - 30, 10, 0, Math.PI * 2); ctx.stroke();
      });
    } else if (mode === 'targetPreview') {
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx, cy + 30, 220, 250, PALETTE.crimson, 'lacquer');
      drawDarumaBody(); ctx.fill();
      ctx.fillStyle = PALETTE.white;
      ctx.beginPath(); ctx.ellipse(cx, cy - 25, 60, 50, 0, 0, Math.PI * 2); ctx.fill();
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx, cy + 80, 90, 60, PALETTE.gold, 'metallic');
      ctx.beginPath(); ctx.ellipse(cx, cy + 80, 45, 30, 0, 0, Math.PI * 2); ctx.fill();
      ctx.fillStyle = PALETTE.black;
      ctx.beginPath(); ctx.arc(cx - 24, cy - 30, 10, 0, Math.PI * 2); ctx.fill();
      ctx.beginPath(); ctx.arc(cx + 24, cy - 30, 10, 0, Math.PI * 2); ctx.fill();
      ShadingPipeline.renderSpecularGlint(ctx, cx - 40, cy, 45, 25, 0.55);
    }
  },

  // STAGE 53: 京扇子・桜金箔
  53: (ctx, cx, cy, mode) => {
    const drawSensu = () => {
      ctx.beginPath();
      ctx.arc(cx, cy + 120, 190, Math.PI * 1.2, Math.PI * 1.8);
      ctx.lineTo(cx, cy + 120);
      ctx.closePath();
    };

    if (mode === 'base') {
      ctx.fillStyle = '#FAF8F5'; drawSensu(); ctx.fill();
    } else if (mode === 'outline') {
      ShadingPipeline.renderCarvedOutline(ctx, () => {
        drawSensu(); ctx.stroke();
        for (let i = -4; i <= 4; i++) {
          const a = Math.PI * 1.5 + i * 0.12;
          ctx.beginPath();
          ctx.moveTo(cx, cy + 120); ctx.lineTo(cx + Math.cos(a) * 190, cy + 120 + Math.sin(a) * 190);
          ctx.stroke();
        }
      });
    } else if (mode === 'targetPreview') {
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx, cy, 260, 190, PALETTE.pink, 'cloth');
      drawSensu(); ctx.fill();
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx, cy - 10, 120, 60, PALETTE.gold, 'metallic');
      ctx.beginPath(); ctx.arc(cx, cy + 40, 50, Math.PI * 1.2, Math.PI * 1.8); ctx.fill();
      ctx.strokeStyle = PALETTE.darkWood; ctx.lineWidth = 3;
      for (let i = -4; i <= 4; i++) {
        const a = Math.PI * 1.5 + i * 0.12;
        ctx.beginPath(); ctx.moveTo(cx, cy + 120); ctx.lineTo(cx + Math.cos(a) * 190, cy + 120 + Math.sin(a) * 190); ctx.stroke();
      }
    }
  },

  // STAGE 54: 鳴子こけし人形
  54: (ctx, cx, cy, mode) => {
    const drawHead = () => {
      ctx.beginPath(); ctx.arc(cx, cy - 75, 55, 0, Math.PI * 2);
    };
    const drawBody = () => {
      ctx.beginPath(); ctx.roundRect(cx - 38, cy - 20, 76, 170, 22);
    };

    if (mode === 'base') {
      ctx.fillStyle = '#FAF8F5'; drawBody(); ctx.fill(); drawHead(); ctx.fill();
    } else if (mode === 'outline') {
      ShadingPipeline.renderCarvedOutline(ctx, () => {
        drawBody(); ctx.stroke();
        drawHead(); ctx.stroke();
        ctx.beginPath(); ctx.arc(cx, cy - 80, 50, Math.PI, 0); ctx.stroke();
      });
    } else if (mode === 'targetPreview') {
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx, cy - 75, 110, 110, PALETTE.ivory, 'wood');
      drawHead(); ctx.fill();
      ctx.fillStyle = PALETTE.black;
      ctx.beginPath(); ctx.arc(cx, cy - 80, 50, Math.PI, 0); ctx.fill();
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx, cy + 65, 76, 170, PALETTE.ivory, 'wood');
      drawBody(); ctx.fill();
      ctx.fillStyle = PALETTE.crimson;
      ctx.fillRect(cx - 38, cy + 15, 76, 35);
      ctx.fillRect(cx - 38, cy + 75, 76, 35);
      ShadingPipeline.renderSpecularGlint(ctx, cx - 20, cy - 90, 20, 20, 0.4);
    }
  },

  // STAGE 55: 江戸風鈴・金魚
  55: (ctx, cx, cy, mode) => {
    const drawGlassBell = () => {
      ctx.beginPath();
      ctx.arc(cx, cy - 50, 75, Math.PI, 0);
      ctx.bezierCurveTo(cx + 75, cy + 10, cx + 55, cy + 25, cx, cy + 25);
      ctx.bezierCurveTo(cx - 55, cy + 25, cx - 75, cy + 10, cx - 75, cy - 50);
      ctx.closePath();
    };

    if (mode === 'base') {
      ctx.fillStyle = '#FAF8F5'; drawGlassBell(); ctx.fill();
      ctx.fillRect(cx - 20, cy + 50, 40, 120);
    } else if (mode === 'outline') {
      ShadingPipeline.renderCarvedOutline(ctx, () => {
        drawGlassBell(); ctx.stroke();
        ctx.strokeRect(cx - 20, cy + 50, 40, 120);
        ctx.beginPath(); ctx.moveTo(cx, cy + 25); ctx.lineTo(cx, cy + 50); ctx.stroke();
      });
    } else if (mode === 'targetPreview') {
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx, cy - 30, 150, 150, PALETTE.cyan, 'glass');
      drawGlassBell(); ctx.fill();
      ctx.fillStyle = PALETTE.coral;
      ctx.beginPath(); ctx.ellipse(cx, cy - 40, 28, 16, 0.3, 0, Math.PI * 2); ctx.fill();
      ctx.fillStyle = PALETTE.white; ctx.fillRect(cx - 20, cy + 50, 40, 120);
      ShadingPipeline.renderSpecularGlint(ctx, cx - 25, cy - 70, 25, 30, 0.65);
    }
  },

  // STAGE 56: 備前焼・信楽壺
  56: (ctx, cx, cy, mode) => {
    const drawUrn = () => {
      ctx.beginPath();
      ctx.moveTo(cx - 45, cy - 140);
      ctx.lineTo(cx + 45, cy - 140);
      ctx.bezierCurveTo(cx + 120, cy - 40, cx + 110, cy + 90, cx + 50, cy + 160);
      ctx.lineTo(cx - 50, cy + 160);
      ctx.bezierCurveTo(cx - 110, cy + 90, cx - 120, cy - 40, cx - 45, cy - 140);
      ctx.closePath();
    };

    if (mode === 'base') {
      ctx.fillStyle = '#FAF8F5'; drawUrn(); ctx.fill();
    } else if (mode === 'outline') {
      ShadingPipeline.renderCarvedOutline(ctx, () => {
        drawUrn(); ctx.stroke();
        ctx.beginPath(); ctx.ellipse(cx, cy - 140, 45, 12, 0, 0, Math.PI * 2); ctx.stroke();
      });
    } else if (mode === 'targetPreview') {
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx, cy, 220, 300, PALETTE.darkWood, 'ceramic');
      drawUrn(); ctx.fill();
      ctx.fillStyle = PALETTE.emerald;
      ctx.beginPath();
      ctx.moveTo(cx - 35, cy - 140);
      ctx.bezierCurveTo(cx - 10, cy - 40, cx + 25, cy - 70, cx + 45, cy - 140);
      ctx.fill();
      ShadingPipeline.renderSpecularGlint(ctx, cx - 35, cy - 20, 25, 55, 0.45);
    }
  },

  // STAGE 57: 金継ぎの抹茶茶碗
  57: (ctx, cx, cy, mode) => {
    const drawBowl = () => {
      ctx.beginPath();
      ctx.moveTo(cx - 120, cy - 50);
      ctx.lineTo(cx + 120, cy - 50);
      ctx.bezierCurveTo(cx + 105, cy + 60, cx + 65, cy + 140, cx + 45, cy + 140);
      ctx.lineTo(cx - 45, cy + 140);
      ctx.bezierCurveTo(cx - 65, cy + 140, cx - 105, cy + 60, cx - 120, cy - 50);
      ctx.closePath();
    };

    if (mode === 'base') {
      ctx.fillStyle = '#FAF8F5'; drawBowl(); ctx.fill();
    } else if (mode === 'outline') {
      ShadingPipeline.renderCarvedOutline(ctx, () => {
        drawBowl(); ctx.stroke();
        ctx.beginPath(); ctx.ellipse(cx, cy - 50, 120, 24, 0, 0, Math.PI * 2); ctx.stroke();
        ctx.beginPath();
        ctx.moveTo(cx - 70, cy - 50); ctx.lineTo(cx - 40, cy + 10); ctx.lineTo(cx - 10, cy + 30); ctx.lineTo(cx - 20, cy + 140);
        ctx.stroke();
      });
    } else if (mode === 'targetPreview') {
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx, cy + 45, 240, 190, PALETTE.black, 'ceramic');
      drawBowl(); ctx.fill();
      ctx.strokeStyle = PALETTE.gold; ctx.lineWidth = 6; ctx.lineCap = 'round';
      ctx.beginPath();
      ctx.moveTo(cx - 70, cy - 50); ctx.lineTo(cx - 40, cy + 10); ctx.lineTo(cx - 10, cy + 30); ctx.lineTo(cx - 20, cy + 140);
      ctx.stroke();
      ShadingPipeline.renderSpecularGlint(ctx, cx - 45, cy + 10, 35, 30, 0.45);
    }
  },

  // STAGE 58: 輪島塗・蒔絵文箱
  58: (ctx, cx, cy, mode) => {
    const drawBox = () => {
      ctx.beginPath();
      ctx.roundRect(cx - 120, cy - 90, 240, 180, 16);
    };

    if (mode === 'base') {
      ctx.fillStyle = '#FAF8F5'; drawBox(); ctx.fill();
    } else if (mode === 'outline') {
      ShadingPipeline.renderCarvedOutline(ctx, () => {
        drawBox(); ctx.stroke();
        ctx.strokeRect(cx - 100, cy - 70, 200, 140);
      });
    } else if (mode === 'targetPreview') {
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx, cy, 240, 180, PALETTE.black, 'lacquer');
      drawBox(); ctx.fill();
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx, cy, 80, 80, PALETTE.gold, 'metallic');
      ctx.beginPath(); ctx.arc(cx, cy, 40, 0, Math.PI * 2); ctx.fill();
      ShadingPipeline.renderSpecularGlint(ctx, cx - 45, cy - 45, 45, 18, 0.65);
    }
  },

  // STAGE 59: 幸運の折り鶴
  59: (ctx, cx, cy, mode) => {
    const drawCrane = () => {
      ctx.beginPath();
      ctx.moveTo(cx, cy - 140);
      ctx.lineTo(cx - 40, cy - 60);
      ctx.lineTo(cx - 140, cy + 30);
      ctx.lineTo(cx - 20, cy + 60);
      ctx.lineTo(cx, cy + 140);
      ctx.lineTo(cx + 20, cy + 60);
      ctx.lineTo(cx + 140, cy + 30);
      ctx.lineTo(cx + 40, cy - 60);
      ctx.closePath();
    };

    if (mode === 'base') {
      ctx.fillStyle = '#FAF8F5'; drawCrane(); ctx.fill();
    } else if (mode === 'outline') {
      ShadingPipeline.renderCarvedOutline(ctx, () => {
        drawCrane(); ctx.stroke();
        ctx.beginPath();
        ctx.moveTo(cx, cy - 60); ctx.lineTo(cx, cy + 60);
        ctx.stroke();
      });
    } else if (mode === 'targetPreview') {
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx, cy, 280, 280, PALETTE.gold, 'cloth');
      drawCrane(); ctx.fill();
      ctx.fillStyle = PALETTE.coral;
      ctx.beginPath(); ctx.moveTo(cx, cy - 60); ctx.lineTo(cx - 140, cy + 30); ctx.lineTo(cx - 20, cy + 60); ctx.closePath(); ctx.fill();
      ctx.fillStyle = PALETTE.purple;
      ctx.beginPath(); ctx.moveTo(cx, cy - 60); ctx.lineTo(cx + 140, cy + 30); ctx.lineTo(cx + 20, cy + 60); ctx.closePath(); ctx.fill();
    }
  },

  // STAGE 60: 魔除けの鬼瓦
  60: (ctx, cx, cy, mode) => {
    const drawTile = () => {
      ctx.beginPath();
      ctx.moveTo(cx, cy - 150);
      ctx.lineTo(cx + 110, cy - 60);
      ctx.lineTo(cx + 95, cy + 120);
      ctx.lineTo(cx - 95, cy + 120);
      ctx.lineTo(cx - 110, cy - 60);
      ctx.closePath();
    };

    if (mode === 'base') {
      ctx.fillStyle = '#FAF8F5'; drawTile(); ctx.fill();
    } else if (mode === 'outline') {
      ShadingPipeline.renderCarvedOutline(ctx, () => {
        drawTile(); ctx.stroke();
        ctx.beginPath(); ctx.arc(cx - 35, cy - 10, 22, 0, Math.PI * 2); ctx.stroke();
        ctx.beginPath(); ctx.arc(cx + 35, cy - 10, 22, 0, Math.PI * 2); ctx.stroke();
        ctx.strokeRect(cx - 45, cy + 45, 90, 30);
      });
    } else if (mode === 'targetPreview') {
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx, cy, 220, 270, PALETTE.charcoal, 'ceramic');
      drawTile(); ctx.fill();
      ctx.fillStyle = ShadingPipeline.createArtisanGradient(ctx, cx, cy - 10, 120, 44, PALETTE.gold, 'metallic');
      ctx.beginPath(); ctx.arc(cx - 35, cy - 10, 22, 0, Math.PI * 2); ctx.fill();
      ctx.beginPath(); ctx.arc(cx + 35, cy - 10, 22, 0, Math.PI * 2); ctx.fill();
      ctx.fillStyle = PALETTE.silver;
      ctx.fillRect(cx - 45, cy + 45, 90, 30);
      ShadingPipeline.renderSpecularGlint(ctx, cx - 35, cy - 80, 35, 20, 0.45);
    }
  }
};
